import React from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, minRole }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">Caricamento…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (minRole) {
    const order = { viewer: 0, sales: 1, estimator: 2, admin: 3, owner: 4 };
    if ((order[user.role] ?? -1) < (order[minRole] ?? 99)) {
      return <section className="sf-flow-error" role="status"><p className="sf-flow-eyebrow">QuoteOS · Accesso alla funzione</p><h1>Questa funzione richiede un altro ruolo</h1><p>Il tuo account non è abilitato a questa operazione. Chiedi al responsabile aziendale di verificare i permessi.</p><div className="sf-flow-actions"><Link to="/dashboard">Torna alla panoramica</Link></div></section>;
    }
  }
  return children;
}
